export default "__VITE_ASSET__550ea664__"